import { clsx } from 'clsx';
import { Tooltip } from "../Tooltip";
import { KSTATUS_CIRCLE_SIZE_CLASSES } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
export var StatusCircle = function StatusCircle(_ref) {
  var size = _ref.size,
    statusProp = _ref.status,
    userName = _ref.userName,
    className = _ref.className;
  var sizeClasses = KSTATUS_CIRCLE_SIZE_CLASSES[size];
  var status = statusProp === 'online' ? 'Online' : 'Offline';
  var label = "".concat((userName === null || userName === void 0 ? void 0 : userName.concat(' ')) || '', "(").concat(status, ")");
  return /*#__PURE__*/_jsx(Tooltip, {
    label: label,
    position: "bottom",
    type: "small",
    children: /*#__PURE__*/_jsx("span", {
      className: clsx(['tw-absolute', 'tw-rounded-full', 'tw-border-neutral-light-100'], className, sizeClasses)
    })
  });
};